import { render, staticRenderFns } from "./userDashboardCustomer.vue?vue&type=template&id=3a5a69be&scoped=true"
import script from "./userDashboardCustomer.vue?vue&type=script&lang=js"
export * from "./userDashboardCustomer.vue?vue&type=script&lang=js"
import style0 from "./userDashboardCustomer.vue?vue&type=style&index=0&id=3a5a69be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5a69be",
  null
  
)

export default component.exports